import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/close.svg'
import _imports_1 from '@/assets/images/trash-red.svg'


const _withScopeId = n => (_pushScopeId("data-v-12a6328b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "delete_event_modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Close Icon",
  width: "14",
  height: "14"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "delete_event_modal_image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Trash Icon",
    width: "100",
    height: "100"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Delete the Event?", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "delete_event_modal_text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to delete this Out Of Hours Event")
], -1))
const _hoisted_7 = { class: "delete_event_modal_footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    width: "460px",
    modelValue: $setup.isShowDeleteModal,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.isShowDeleteModal) = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "delete_event_modal_close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onClickCancelButton && $setup.onClickCancelButton(...args)))
        }, _hoisted_3),
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Button, {
            class: "button",
            label: "CANCEL",
            variant: "secondary",
            onClick: $setup.onClickCancelButton
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            class: "button",
            label: "DELETE",
            variant: "accent",
            onClick: $setup.onClickDeleteButton
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}